var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clock_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ED6C5B",
    fillRule: "evenodd",
    d: "M12.5 2.203c-5.413 0-9.8 4.388-9.8 9.8s4.387 9.8 9.8 9.8c5.411 0 9.8-4.388 9.8-9.8s-4.389-9.8-9.8-9.8m-8.2 9.8a8.2 8.2 0 1 1 16.4.002 8.2 8.2 0 0 1-16.4-.002m9-5.39a.8.8 0 0 0-1.6 0v5.17a.8.8 0 0 0 .299.625l3.32 2.66a.8.8 0 0 0 1-1.25L13.3 11.4z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clock_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h24v24H.5z"
  })))));
};
export default SvgClock;